import React, {Component} from 'react';
import Page from '../../components/Page';
import {getProjects, updateProject, createProject, deleteProject} from '../../actions/projects';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import _ from 'lodash';
import Modal from 'react-responsive-modal';
import './styles.css';


const DEFAULT_STATE = {
    open: false,
    isActive: false,
    action: '',
    _id: '',
    name: '',
};

class Projects extends Component {

    constructor(props) {
        super(props);
        this.state = DEFAULT_STATE;
        this._onClickEdit = this._onClickEdit.bind(this);
        this._onClickRemove = this._onClickRemove.bind(this);
        this._onCloseModal = this._onCloseModal.bind(this);
        this._onChangeInput = this._onChangeInput.bind(this);
        this._onClickAction = this._onClickAction.bind(this);
        this._onClickCreate = this._onClickCreate.bind(this);
        this._onChangeSingleValueCheckBox = this._onChangeSingleValueCheckBox.bind(this);
    }

    componentWillMount() {
        this.props.dispatch(getProjects())
    }

    _onClickEdit(project) {
        let state = Object.assign({}, {open :true, action: 'Edit'}, _.omit(project, ['createdAt', 'updatedAt']));
        this.setState(state);
    }

    _onClickCreate() {
        let state = Object.assign({}, DEFAULT_STATE, {open :true, action: 'Create'});
        this.setState(state);
    }

    _onClickAction() {
        let omits = ['_id', 'open', 'action'];

        let data = _.omit(this.state, omits);

        if (this.state.action === 'Edit') {
            this.props.dispatch(updateProject((error, json)=> {
                if (!error) {
                    let state = Object.assign({}, DEFAULT_STATE);
                    this.setState(state);
                }
            }, this.state._id, data));
        } else if (this.state.action === 'Create') {
            this.props.dispatch(createProject((error, json)=> {
                if (!error) {
                    let state = Object.assign({}, DEFAULT_STATE);
                    this.setState(state);
                }
            }, data));
        }
    }

    _onClickRemove(id) {
        this.props.dispatch(deleteProject(()=> {}, id));
    }

    _onCloseModal() {
        let state = Object.assign({}, DEFAULT_STATE);
        this.setState(state);
    };

    _onChangeInput(property, event) {
        let state = Object.assign({}, this.state);
        state[property] = event.target.value;
        this.setState(state);
    }

    _onChangeSingleValueCheckBox(property, event) {
        let state = Object.assign({}, this.state);
        if (state[property]) {
            state[property] = false;
        } else {
            state[property]  = true;
        }
        this.setState(state);
    }

    render() {
        let projects = [];

        this.props.projects.forEach((project, index) => {
            projects.push(<tr key={'project_' + index}>
                <td><span className="User-Cell"><i className="fa fa-folder-o" style={{color: 'var(--brand-600)'}} /> {project.name}</span></td>
                <td>{project.isActive
                    ? <span className="Badge Badge--approved">Active</span>
                    : <span className="Badge Badge--canceled">Inactive</span>}</td>
                <td style={{textAlign: 'center'}}>
                    <button onClick={()=> this._onClickEdit(project)} className="btn btn-default" title="Edit project">
                        <i className="fa fa-pencil" style={{color: 'var(--brand-700)'}} aria-hidden="true"></i>
                    </button>
                </td>
            </tr>);

        });
        if (!projects.length) {
            projects.push(<tr key="projects_empty"><td colSpan="3"><div className="Empty"><i className="fa fa-folder-o" /><div className="t">No projects yet</div></div></td></tr>);
        }

        return (
            <Page {...this.props} >

                <Modal open={this.state.open} onClose={this._onCloseModal} little>

                    <div className="Modal-Head"><h3>{this.state.action === 'Create' ? 'New project' : 'Edit project'}</h3></div>

                    <div className="Modal-Body">
                        <div className="Input-Group">
                            <label>Name</label>
                            <input type="text" className="form-control" placeholder="Project name"
                                   value={this.state.name}
                                   onChange={event => this._onChangeInput('name', event)}
                            />
                        </div>
                        <label className="Check-Row">
                            <input type="checkbox"
                                   checked={this.state.isActive}
                                   onChange={event => this._onChangeSingleValueCheckBox('isActive', event)}
                            /> Active
                        </label>
                    </div>

                    <div className="Modal-Foot">
                        <button type="button" className="btn btn-default" onClick={this._onCloseModal}>Cancel</button>
                        <button type="button" className="btn btn-primary" onClick={this._onClickAction}>
                            {this.state.action === 'Create' ? 'Create project' : 'Save changes'}
                        </button>
                    </div>

                </Modal>

                <div className="col-xs-12">
                    <div className="Plus-Icon" title="Create project" onClick={this._onClickCreate}>
                        <i className="fa fa-plus-circle" aria-hidden="true"></i>
                    </div>
                    <div className="Card" style={{padding: 0}}>
                        <div className="Table-Wrap" style={{border: 0}}>
                            <table className="table">
                                <thead>
                                <tr>
                                    <th scope="col">Name</th>
                                    <th scope="col">Status</th>
                                    <th scope="col" style={{textAlign: 'center'}}>Actions</th>
                                </tr>
                                </thead>
                                <tbody>
                                {projects}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </Page>
        );
    }
}

Projects.propTypes = {
    projects: PropTypes.arrayOf(PropTypes.object),
};

Projects.defaultProps = {
    projects: [],
};


function mapStateToProps(state) {
    const projects = state.projects;
    return {
        projects: projects,
    };
}

export default connect(mapStateToProps)(Projects);



// WEBPACK FOOTER //
// ./src/screens/Projects/index.js